import React from 'react';
import {Link} from 'react-router-dom';
import CountUp from 'react-countup';

import { FaInstagram,FaLinkedin } from "react-icons/fa";
import slide from './../assets/images/main-slider/pic1.png';
import NewYouthWingFlyer from './../assets/images/SATS club/youth/youth_club_flyer.jpg';
import { YouthWingsimg } from "../constant/theme"
import { Row } from 'reactstrap';
import { Col } from 'react-bootstrap';

const CounterBlog = [
    {title:"Total Donor", number:"4556"},
    {title:"Volunteer", number:"874"},
    {title:"Total Donation", number:"195234"},
];

const YouthWingBlock = () =>{
    return(
        <>
            <div className="col-lg-7">
                <div className="dz-media">
                    <img src={NewYouthWingFlyer} alt="image" />
                </div>
            </div>
            <div className="col-lg-5 m-b50">
                <div className="section-head">
                    <h3 className='text-primary'>SATS Youth Wing (இளைஞர் பாசறை)</h3>
                    <p className="m-t20" style={{lineHeight:1.5}}>San Antonio Tamil Sangam Youth Wing proudly welcomes our future leaders. Today’s youth are tomorrow’s leaders and SATS empowers future leaders with the power for the development of the community.</p>
                </div>

                <div className="section-head">
                    <h6 className='text-primary'>First Priority</h6>
                    <p className="m-t20" style={{ lineHeight: 1.5, fontSize:13 }}> Our first priority is to promote participation in
                        community volunteering, mentoring relationships that
                        support the critical, social, and emotional
                        development needed to help build resilience among
                        youth.</p>
                </div>

                <div className="section-head">
                    <h6 className='text-primary'>Our Mission</h6>
                    <p className="m-t20" style={{ lineHeight: 1.5, fontSize:13 }}>To support and mentor our youth and to ignite their
                        power and potential. In addition, SATS will provide a
                        safe, productive and social environment to youths and
                        promote self-growth.</p>
                </div>

            
                <div className="section-head">
                    <h6 className='text-primary'>Interested to join Youth of San Antonio Tamil Sangam (YOSATS)</h6>
                    <Link
                      to={"/youthwingForm"}
                      className="btn btn-sm btn-warning text-light "
                    >
                      Join Here
                    </Link>
                </div>
                 <div className="section-head">
                    <Row>
                        <Col xs="12" 
                         md="2" >
                        <a href="https://www.instagram.com/sats_youthwing?igsh=aDVvbTR4bjE2bzgw"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: "40px",
                                height: "40px",
                                backgroundColor: "white",
                                borderRadius: "50%",
                                textDecoration: "none",
                                }}
                            >
                            <FaInstagram color="red" size={24} />
                            </a>
                        </Col>
                        <Col xs="12" md="10" className="d-flex center mt-2">
                        <h6 className='text-primary'>Follow us on Instagram</h6>
                        </Col>
                    </Row>
                     
                </div>
                 <div className="section-head">
                    <Row>
                        <Col xs="12" 
                         md="2" >
                        <a href="https://www.linkedin.com/company/satsyw/?viewAsMember=true"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: "40px",
                                height: "40px",
                                backgroundColor: "white",
                                borderRadius: "50%",
                                textDecoration: "none",
                                }}
                            >
                            <FaLinkedin color="blue" size={24} />
                            </a>
                        </Col>
                        <Col xs="12" md="10" className="d-flex center mt-2">
                        <h6 className='text-primary'>Linkedin</h6>
                        </Col>
                    </Row>
                     
                </div>
                
            </div>
        </>
    )
}
export default YouthWingBlock;